import PropTypes from 'prop-types';
import { DB_PREFIX_MANDATORY, DB_PREFIX_EXTRA } from './constants';

export default PropTypes.shape({
  [DB_PREFIX_MANDATORY]: PropTypes.shape({}),
  [DB_PREFIX_EXTRA]: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      fileURL: PropTypes.string,
    })
  ),
});
